<template>
  <small> INCLUYE COMISIÓN DEL {{ this.commission }}%</small>
</template>

<script>
export default {
  props: {
    commission: { type: Number, default: 0 },
  },
};
</script>
